/**
 * Same-Origin-Sitzungsabgleich: Der Tester läuft im Vhost der Kundenanwendung
 * (§2.1) — beide teilen sich localStorage. Hat die eingebettete App dort noch
 * Logto-Tokens EINES ANDEREN Benutzers (z. B. aus einer früheren Sitzung im
 * selben Fenster), würde sie diesen stillschweigend weiterverwenden, statt die
 * SSO-Identität des Tester-Logins zu übernehmen — Tester und App zeigten dann
 * verschiedene Benutzer.
 *
 * Darum nach dem Tester-Login: fremde Logto-Bestände mit abweichendem `sub`
 * entfernen. Die App findet beim Laden des iframes keine Tokens mehr, leitet
 * zu Logto weiter und bekommt dort per SSO-Sitzung automatisch DENSELBEN
 * Benutzer wie der Tester — ohne erneute Passwortabfrage.
 *
 * Schlüsselformat @logto/browser: `logto:<appId>` bzw. `logto:<appId>:<item>`;
 * idToken/refreshToken liegen im localStorage, signInSession im sessionStorage.
 */

function subAusJwt(token: string): string | null {
  try {
    const payload = token.split(".")[1]
    if (!payload) return null
    const claims = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/"))) as {
      sub?: unknown
    }
    return typeof claims.sub === "string" ? claims.sub : null
  } catch {
    return null
  }
}

export function fremdeLogtoSitzungenAngleichen(eigeneAppId: string, testerSub: string): void {
  // Fremde Logto-App-IDs mit Beständen auf diesem Origin einsammeln
  const fremdeAppIds = new Set<string>()
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (!key?.startsWith("logto:")) continue
    const appId = key.split(":")[1]
    if (appId && appId !== eigeneAppId) fremdeAppIds.add(appId)
  }

  for (const appId of fremdeAppIds) {
    const idToken = localStorage.getItem(`logto:${appId}:idToken`)
    // Sitzung gehört bereits dem Tester-Benutzer → unangetastet lassen
    if (idToken && subAusJwt(idToken) === testerSub) continue

    for (const speicher of [localStorage, sessionStorage]) {
      const zuLoeschen: string[] = []
      for (let i = 0; i < speicher.length; i++) {
        const key = speicher.key(i)
        if (key === `logto:${appId}` || key?.startsWith(`logto:${appId}:`)) {
          zuLoeschen.push(key)
        }
      }
      for (const key of zuLoeschen) speicher.removeItem(key)
    }
  }
}
